import React from 'react';
import Image from 'react-bootstrap/Image';

import CompanyIcon from './Decorator/CompanyIcon';
import AcceptationGuideCell from './Decorator/Filter/AcceptationGuideCell';
import InterestCell from './Decorator/Filter/InterestCell';
import ExportPDF from './Decorator/News/ExportPDF';
import ProductDeviation from './Decorator/News/ProductDeviation';
import PropertyAttributesCell from './Decorator/ProductProperties/PropertyAttributesCell';
import FormattedDate from '../../General/FormattedDate';

import { CellDecorator } from '../../../Enum/TableDecorator';
import { Cell, LabelDeviation } from '../../../Interface/Hook/Interest/InterestTableDTO';
import { ExportPdf } from '../../../Interface/Response/Interest/ExportPdf';
import { PropertyAttributes } from '../../../Interface/Response/Interest/PropertyAttributes';
import { Interest } from '../../../Interface/Response/Interest/Interest';
import { Cell as IAcceptationGuideCell } from '../../../Interface/Response/Interest/AcceptationGuideData';

const CellContent: React.FC<Cell> = ({ decorator, value, appendix }: Cell) => (
    <>
        {!decorator && (
            value
        )}
        {decorator === CellDecorator.LabelDeviation && (
            <ProductDeviation label={value as LabelDeviation} />
        )}
        {decorator === CellDecorator.Image && (
            <Image src={value as string} height={22} />
        )}
        {decorator === CellDecorator.CompanyIcon && (
            <CompanyIcon finDataCode={value as string} />
        )}
        {decorator === CellDecorator.ExportPDF && (
            <ExportPDF
                pdfUrl={(value as ExportPdf).pdfUrl}
                externalPdfUrl={(value as ExportPdf).externalPdfUrl}
                disableExternal={(value as ExportPdf).disableExternal}
            />
        )}
        {decorator === CellDecorator.Date && (
            <FormattedDate date={value as string} />
        )}
        {decorator === CellDecorator.ProductProperty && (
            <PropertyAttributesCell {...(value as PropertyAttributes)} />
        )}
        {decorator === CellDecorator.Interest && (
            <InterestCell interest={value as Interest} />
        )}
        {decorator === CellDecorator.AcceptationGuide && (
            <AcceptationGuideCell {...(value as IAcceptationGuideCell)} />
        )}
        {appendix !== undefined && appendix}
    </>
);

export default CellContent;
